import { z } from 'zod';

export const HealthResponse = z.object({ status: z.literal('ok') });
export type HealthResponse = z.infer<typeof HealthResponse>;

export const ErrorResponse = z.object({
  error: z.string(),
  message: z.string().optional(),
});
export type ErrorResponse = z.infer<typeof ErrorResponse>;

export * from './auth.js';
export * from './admin.js';
export * from './members.js';
export * from './search.js';
export * from './matches.js';
export * from './map.js';
export * from './account.js';
export * from './backup.js';
export * from './analytics.js';
export * from './network.js';
export * from './join.js';
export * from './feedback.js';
export * from './groups.js';
